import { Component, inject,Inject } from '@angular/core';
import { MatSnackBar,MatSnackBarHorizontalPosition,MatSnackBarVerticalPosition, } from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'lib-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.css',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule],
})
export class SnackbarComponent {
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  private _snackBar = inject(MatSnackBar);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { title: string, messages: string }) {}

  openSnackBar(title: string, messages: string) {
    this._snackBar.open(`${title}: ${messages}`, 'Close',{
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

}